import CrudAPIClient from '../crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { MetaQuery } from '@refinedev/core';
import { axiosInstance } from '../axios';

export default class BundleUploadAPIClient extends CrudAPIClient {
  constructor() {
    super(GATEWAY_API_URL + '/catalog/product/bundleupload');
  }

  async search(query: any, page: number, size: number): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async create(payload: any): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async updateById(id: any, data: any): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async findBulk(ids: any[]): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async findById(id: any): Promise<any> {
    throw new Error('Unimplemented method');
  }

  // @ts-ignore
  async createMany(payload: any[], meta: MetaQuery | undefined): Promise<any> {
    try {
      const bundles = payload.map(bundle => ({
        bundleProduct1: bundle.bundleProduct1 || null,
        bundleProduct2: bundle.bundleProduct2 || null,
        bundleProduct3: bundle.bundleProduct3 || null,
        bundleProduct4: bundle.bundleProduct4 || null,
        bundleProduct5: bundle.bundleProduct5 || null,
      }));

      const requestBody = {
        bundles: bundles,
      };

      const response = await axiosInstance.post(`${this.baseURL}`, requestBody);

      return this.transformList(response.data.data);
    } catch (error) {
      console.error(`Error creating bundles in bulk:`, error);
      throw error;
    }
  }
}
